<template>
  <v-app>
    <div class="d-flex justify-center mt-3">
      <v-card width="593" class="pa-0 ma-0">
        <Preview :linkInBio="linkInBio" v-if="linkInBio != null" :isWebPage="true" />
      </v-card>
    </div>
  </v-app>
</template>

<script>
import Preview from "@/components/LinkInBio/Preview";
import { mapActions } from "vuex";
import {getDocById} from "@/shared/firebase_utils";

export default {
  components: {
    Preview,
  },
  created() {
    let linkInBioId = this.$route.params.linkInBioId;


    //Get linkInBio doc from firestore
    getDocById("link_in_bio", linkInBioId)
      .then((document) => {
        this.linkInBio = document.data();
        //Get businessProfile doc from firestore
        this.initializeBusinessProfile(this.linkInBio.businessProfileId);
      })
      .catch((error) => {
        console.log("Error occurred while retrieving link in bio: ", error);
      });
  },
  data() {
    return {
      linkInBio: null,
    };
  },
  methods: {
    ...mapActions(["initializeBusinessProfile"]),
  },
};
</script>

<style></style>
